<div class="form-field">
    @if(label) {
      <label class="form-field__label">
        {{ label }}
        @if(required) {
          <span class="form-field__required">*</span>
        }
      </label>
    }

    <input
      #fieldInput
      [type]="type"
      [id]="formControlName"
      [placeholder]="placeholder"
      [pattern]="pattern"
      [required]="required"
      [disabled]="control?.disabled || disable"
      (input)="onInput($event)"
      (blur)="onBlurField($event)"
      class="form-field__input form-field__input--{{ size }}"
      [ngClass]="{
        'form-field__input--invalid': isInvalid,
        'form-field__input--disabled': control?.disabled
      }"
    />

    @if (errorMessage) {
      <div class="form-field__error">
        {{ errorMessage }}
      </div>
    }
  </div>
